import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = this.addToken(request);
    return next.handle(request);
  }


  private addToken(request: HttpRequest<unknown>) {
    /* if (request.url.includes('logixpense.com:2924')) {
      return request;
    } */

    const token = this.authService.getToken();
    if (request.url.includes('GuardarImagenGaleria')) { }
    if (token && !request.url.includes('/extract-invoice-data') && token && !request.url.includes('/extract-bank-statement-data') && (token && !request.url.includes('/extract-invoice-complete-data'))) {
      let authReq
      if (request.url.includes('GuardarImagenGaleria')) {
        authReq = request.clone({
          setHeaders: {
            'idUsuario': this.authService.getIdUsuario(),
            'idCliente': this.authService.getIdCliente(),
          },
        });

      } else {
        authReq = request.clone({
          setHeaders: {
            'Authorization': `Bearer ${token}`,
            'idUsuario': this.authService.getIdUsuario(),
            'idCliente': this.authService.getIdCliente(),
          },
        });

      }
      return authReq;
    }
    return request;
  }
}
